module.exports = "/_next/static/images/icon-login-wechat-5a321264.png";